import React, { useEffect } from 'react';

import { Box } from '@chakra-ui/react';
import { useRouter } from 'next/router';

import LoginForm from '@/components/Auth/LoginForm';
import { Section } from '@/components/Layout';
import Page from '@/components/Pages/Page';
import { useAuth } from '@/context/AuthContext';
import { H2 } from '@/elements';

export default function SignIn() {
  const router = useRouter();
  const { isAuthenticated } = useAuth();

  // redirect if signed in
  useEffect(() => {
    if (isAuthenticated) {
      router.push('/dashboard');
    }
  }, [isAuthenticated, router]);

  return (
    <Page>
      <Section>
        <Box marginX='auto' maxW={900} mt='xxl'>
          <Box mb='2'>
            <H2 color='white'>Sign in</H2>
          </Box>
          <Box>
            <LoginForm />
          </Box>
        </Box>
      </Section>
    </Page>
  );
}
